
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaiinnovacabs() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Innova Cab',
        heading: 'Prince Cabs: Pune to Mumbai Innova Cab',
        headingDescription: 'Prince Cabs provides reliable Pune to Mumbai Innova Cab services, ideal for airport transfers, corporate travel, family trips, and long-distance journeys. Our spacious Innova and Innova Crysta vehicles are well-maintained and equipped with modern amenities to ensure a safe and comfortable ride on the Pune–Mumbai Expressway. With professional chauffeurs, punctual pickups, and flexible travel options, we make your journey hassle-free and enjoyable. Experience convenience, comfort, and affordability with Prince Cabs’ trusted Innova cab service from Pune to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most iconic landmark overlooking the Arabian Sea. It was constructed to commemorate the visit of King George V and Queen Mary. The Indo-Saracenic architecture and historic charm attract tourists from across the world. Ferries to Elephanta Caves depart from here, adding to its significance. The site is lively with vendors, photographers, and street performers. At sunset, the monument glows beautifully, making it perfect for photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the ‘Queen’s Necklace,’ is a 3.6 km long boulevard along the Arabian Sea. Its streetlights at night resemble a sparkling necklace, offering a romantic view. People come here for evening walks, jogging, and to enjoy sea breezes. The spot is especially famous for its magical sunsets. During monsoon, crashing waves create a thrilling spectacle. It reflects Mumbai’s vibrancy and is a favorite hangout for locals and tourists alike."
  },
  {
    "title": "Elephanta Caves",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island, about an hour’s ferry ride from Mumbai. Dating back to the 5th–6th century, the caves are dedicated to Lord Shiva. The Trimurti sculpture, depicting Shiva in three forms, is the main highlight. Intricate carvings, courtyards, and pillars showcase India’s artistic heritage. Surrounded by greenery and sea views, the caves combine history, spirituality, and nature. They are a must-visit for culture lovers."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and a bustling railway station. Built in 1887 in Victorian Gothic Revival style, it features domes, stained glass, and detailed carvings. It is not just a transport hub but a symbol of Mumbai’s colonial history. At night, the building glows with stunning lights, making it a photographer’s delight. Tourists admire its grandeur while experiencing Mumbai’s lifeline—the local trains. It blends history with modern urban energy."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an engineering marvel that connects the suburbs to South Mumbai. This 8-lane cable-stayed bridge offers breathtaking views of the Arabian Sea and the skyline. At night, it is illuminated, creating a spectacular sight. The sea link significantly reduces travel time, making it vital for commuters. Driving across it is both thrilling and scenic. It represents modern Mumbai’s progress and architectural brilliance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, known for its lively atmosphere and street food stalls. Vendors sell local favorites like pav bhaji, bhel puri, and ice gola. The beach is also famous for Bollywood celebrity homes nearby, attracting star-struck visitors. Families gather here in the evenings to enjoy the sea breeze. Sunsets at Juhu are magical, painting the sky in golden hues. It is both a cultural hub and a coastal retreat within the city."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet off Worli. Dedicated to Pir Haji Ali Shah Bukhari, it features Indo-Islamic architecture with white domes and marble courtyards. The dargah is accessible via a narrow causeway during low tide, adding to its charm. People of all faiths visit for blessings and peace. Its serene setting against the sea makes it one of Mumbai’s most spiritual landmarks. Festivals and qawwalis enhance its allure."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Spread across 87 sq. km, Sanjay Gandhi National Park is a green oasis within Mumbai. It is home to leopards, deer, birds, and scenic trekking trails. Inside the park, the Kanheri Caves feature Buddhist monasteries and stupas dating back to the 1st century BC. The caves highlight ancient rock-cut architecture and spirituality. The park also offers boating, cycling, and a toy train for families. It is a rare combination of nature and history within a metropolitan city."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market, famous for shopping and food. From trendy clothes to antique jewelry and handicrafts, it offers everything. Tourists love bargaining while exploring its colorful shops. The area also houses iconic cafés like Leopold Café and Café Mondegar. The lively vibe makes it a hotspot for both locals and travelers. It is the best place to experience Mumbai’s cosmopolitan spirit and street culture. Shopping here is a must-do activity."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Located in Prabhadevi, Siddhivinayak Temple is Mumbai’s most famous temple dedicated to Lord Ganesha. Built in 1801, the temple attracts lakhs of devotees, including Bollywood stars and politicians. The gold-plated dome and intricately carved wooden doors add to its grandeur. Tuesdays are especially crowded with long queues of worshippers. It is believed that prayers here are always fulfilled. The temple is a powerful spiritual landmark in the heart of the city."
  },
  {
    "title": "Chowpatty Beach & Girgaon",
    "description": "Chowpatty Beach, located in South Mumbai, is famous for its festive vibe and Ganesh Visarjan celebrations. Families gather to enjoy street food like pav bhaji, bhel puri, and kulfi. Evening walks along the shore are relaxing with views of Marine Drive. The nearby Girgaon area is rich in heritage with temples, old chawls, and bustling markets. Together, they showcase Mumbai’s cultural and local lifestyle. It is an essential stop for experiencing the city’s flavor."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City, spread across 520 acres in Goregaon, is the heart of Bollywood. It features multiple studios, sets, and artificial landscapes used for shooting films and TV shows. Guided tours allow visitors to see behind-the-scenes of India’s film industry. From palace sets to rural backdrops, it offers diverse filming environments. Fans love exploring the glamour of Bollywood here. It is a unique attraction connecting Mumbai’s identity to cinema."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is a scenic artificial lake in Mumbai, surrounded by modern skyscrapers and lush greenery. It is a popular spot for birdwatching, with sightings of kingfishers, herons, and migratory birds. Locals come here for morning walks, photography, and relaxation. The lake is especially beautiful during monsoon. Its calm waters create a serene backdrop for the bustling city. Powai adds natural balance to Mumbai’s urban lifestyle."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda, located near Gorai, is a massive meditation dome built in Burmese architectural style. It houses relics of Buddha and can accommodate over 8,000 meditators. The golden dome is one of the world’s largest stone monuments without supporting pillars. Visitors come for guided meditation sessions and spiritual learning. Its peaceful location by the sea makes it ideal for reflection. The pagoda is both an architectural wonder and a spiritual retreat."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Located in Worli, the Nehru Planetarium and Science Centre is an educational and entertaining attraction. The planetarium hosts shows on astronomy, stars, and space exploration with advanced projection systems. The adjoining science center has interactive exhibits on science and technology. Visitors also explore art galleries and a dome-shaped auditorium. It is popular among families and students. Together, they make Mumbai a hub for learning and curiosity."
  }
],


"services": [
    {
        "name": "Pune to Mumbai Airport Drop Innova",
        "description": "Reliable and comfortable Innova taxi service for airport drop from Pune to Mumbai. Enjoy a hassle-free ride with professional drivers, spacious seating, and timely pickups to ensure you reach Mumbai airport on schedule with all your luggage safely handled."
    },
    {
        "name": "Pune Mumbai Innova Rental",
        "description": "Rent an Innova for your Pune to Mumbai trip with flexible rental options, perfect for families, business travelers, and groups. Our Innova rentals offer premium comfort, ample space, and experienced chauffeurs for a smooth journey between the two cities."
    },
    {
        "name": "Pune to Mumbai Airport Innova",
        "description": "Book Innova cab service from Pune to Mumbai Airport with guaranteed punctuality and clean vehicles. Perfect for solo travelers, families, or corporate clients needing a comfortable ride to the airport with all necessary amenities included."
    },
    {
        "name": "Pune to Mumbai Innova",
        "description": "Safe and reliable Innova cab service for direct travel from Pune to Mumbai. Our service guarantees well-maintained vehicles, professional drivers, and affordable rates, making your intercity travel comfortable and stress-free."
    },
    {
        "name": "Pune Mumbai Innova",
        "description": "Efficient Innova rental service for travel between Pune and Mumbai. Whether it’s for corporate trips, family outings, or weekend getaways, our Innova cabs provide a perfect blend of comfort, safety, and affordability."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Book an Innova cab from Pune to Mumbai for a spacious, air-conditioned, and smooth ride. Our drivers are courteous and knowledgeable of the best routes to avoid traffic, ensuring timely arrivals for all your appointments or leisure plans."
    },
    {
        "name": "Pune to Mumbai Round Trip Innova Cab",
        "description": "Convenient round-trip Innova cab service between Pune and Mumbai, perfect for business trips, family visits, and tours. Enjoy the comfort of the same vehicle and driver for your return journey, with flexible scheduling and competitive pricing."
    },
    {
        "name": "Pune to Mumbai Innova Crysta Taxi",
        "description": "Travel in style and comfort with our Innova Crysta taxi service from Pune to Mumbai. Featuring premium interiors and added amenities, this service is ideal for those who value luxury alongside reliable transportation."
    },
    {
        "name": "Pune to Mumbai Dzire vs Innova Cab",
        "description": "Compare Dzire and Innova cabs for Pune to Mumbai travel. Choose Innova for more space and comfort, ideal for family or group travel, or Dzire for economical and efficient rides. Our fleet offers both options with professional drivers and transparent pricing."
    },
    {
        "name": "Pune to Mumbai Family Innova",
        "description": "Family-friendly Innova cab service from Pune to Mumbai designed to accommodate all your travel needs including child safety seats, spacious interiors, and a comfortable environment for a relaxed journey with your loved ones."
    },
    {
        "name": "Affordable Innova Pune to Mumbai",
        "description": "Affordable Innova cab services for Pune to Mumbai travelers who want quality and comfort without breaking the bank. Transparent pricing, no hidden charges, and reliable vehicles ensure you get the best value for your money."
    },
    {
        "name": "Pune to Mumbai Innova Cab Service",
        "description": "Top-rated Innova cab service for seamless travel from Pune to Mumbai. With on-time pickups, courteous drivers, and well-maintained vehicles, we ensure a safe and pleasant ride every time."
    },
    {
        "name": "Innova Crysta Pune to Mumbai Tour",
        "description": "Exclusive Innova Crysta tour packages from Pune to Mumbai tailored for business trips, leisure tours, and family outings. Experience luxury, comfort, and professional service while exploring the best of both cities."
    }
],
"tableData": [
    ["Pune to Mumbai Airport Drop Innova", "Pune Mumbai Innova Rental"],
    ["Pune to Mumbai Airport Innova", "Pune to Mumbai Innova"],
    ["Pune Mumbai Innova", "Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai Round Trip Innova Cab", "Pune to Mumbai Innova Crysta Taxi"],
    ["Pune to Mumbai Dzire vs Innova Cab", "Pune to Mumbai Family Innova"],
    ["Affordable Innova Pune to Mumbai", "Pune to Mumbai Innova Cab Service"],
    ["Innova Crysta Pune to Mumbai Tour", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Innova Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and comfortable Toyota Innova cab services from Pune to Mumbai, ideal for business travelers, families, and groups. Our Innova vehicles ensure a smooth and spacious ride along the highway, allowing you to reach Mumbai safely and on time, whether you’re heading to the airport, office, or exploring the city."
    },
    {
        "WhyChooseheading": "Spacious and Premium Innova Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained, air-conditioned Toyota Innova and Innova Crysta models that provide ample legroom, reclining seats, and large luggage space. Perfect for long journeys, these vehicles ensure you travel in comfort and style between Pune and Mumbai."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Route",
        "WhyChoosedescription": "Our professional drivers are knowledgeable about the best routes and traffic conditions between Pune and Mumbai. They prioritize your safety and timely arrivals, making your intercity trip hassle-free with courteous and skilled driving."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Your Travel Needs",
        "WhyChoosedescription": "Whether you need a one-way transfer, round trip, or multi-day rental for sightseeing in Mumbai, Prince Cabs offers customizable packages. Book easily via phone, WhatsApp, or online portal, with instant confirmations and transparent pricing."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "All our Innova cabs are thoroughly cleaned and sanitized before each trip. We adhere to strict safety protocols to provide a safe, healthy, and comfortable journey between Pune and Mumbai."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Options",
        "WhyChoosedescription": "We offer competitive and clear pricing with no hidden charges. Payments can be made securely via UPI, credit/debit cards, net banking, or cash, providing you flexibility and peace of mind."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for a Smooth Experience",
        "WhyChoosedescription": "Our customer care team is available 24/7 to assist you throughout your Pune to Mumbai Innova cab journey, ensuring prompt responses and hassle-free coordination."
    }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Innova cab service from Pune to Mumbai?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable Toyota Innova and Innova Crysta cab services from Pune to Mumbai for one-way, round-trip, and airport transfers.',
    },
    {
        question: 'What is the fare for a Pune to Mumbai Innova cab?',
        answer: 'The fare typically starts from ₹3,800 for a one-way trip in a standard Innova. Rates may vary depending on pickup point, drop location, and time of travel.',
    },
    {
        question: 'How long does the Pune to Mumbai journey take by Innova?',
        answer: 'The journey usually takes around 3.5 to 4.5 hours depending on traffic and road conditions. Innova offers ample space and comfort for long drives.',
    },
    {
        question: 'Can I book an Innova Crysta for Pune to Mumbai travel?',
        answer: 'Absolutely! We offer both standard Innova and premium Innova Crysta options. Crysta cabs provide enhanced comfort, captain seats, and smoother ride quality.',
    },
    {
        question: 'Is the Pune to Mumbai Innova cab available 24/7?',
        answer: 'Yes, Prince Cabs operates round-the-clock. You can book a Pune to Mumbai Innova cab anytime for early morning or late-night travel.',
    },
    {
        question: 'Are tolls and parking included in the fare?',
        answer: 'Tolls and parking are usually charged extra on top of the base fare. A detailed fare breakup is shared at the time of booking for complete transparency.',
    },
    {
        question: 'How can I book a Pune to Mumbai Innova cab with Prince Cabs?',
        answer: 'Simply visit our website or call our customer support to book. Share your travel details, and we’ll assign a verified driver and clean, comfortable Innova for your trip.',
    },
];

const testimonials = [
    {
        name: "Mr. Nilesh Bhosale",
        position: "Frequent Intercity Commuter",
        text: "Booked an Innova from Pune to Mumbai with Prince Cabs. The car was spotless, ride was smooth, and the driver was highly professional. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-1.png",
    },
    {
        name: "Mrs. Rupal Mehta",
        position: "Senior Citizen Traveler",
        text: "We traveled to Mumbai airport in an Innova Crysta. Comfortable ride and on-time pickup. Prince Cabs took care of everything. Will definitely book again.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Innova Cab",
  "image": "https://princecab.com/assets/images/pune-to-mumbai-innova-cab.jpg",
  "description": "Book Pune to Mumbai Innova cab with Prince Cabs for comfortable, reliable, and affordable travel. Perfect for airport transfers, round trips, family rides, and outstation tours.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-mumbai-innova-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Innova Cab | Reliable & Comfortable Ride | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mumbai Innova cab service with Prince Cabs for affordable, reliable, and comfortable travel options including airport drop, round trips, and family rides."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Drop Innova, Pune Mumbai Innova Rental, Pune to Mumbai Airport Innova, Pune to Mumbai Innova, Pune Mumbai Innova, Pune to Mumbai Innova Cab, Pune to Mumbai Round Trip Innova Cab, Pune to Mumbai Innova Crysta Taxi, Pune to Mumbai Dzire vs Innova Cab, Pune to Mumbai Family Innova, Affordable Innova Pune to Mumbai, Pune to Mumbai Innova Cab Service, Innova Crysta Pune to Mumbai Tour"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiinnovacabs;